<script setup lang="ts">
import zhCN from 'ant-design-vue/es/locale/zh_CN'
</script>

<template>
  <a-config-provider
    :locale="zhCN"
    :theme="{
      token: {
        colorPrimary: '#1677ff',
        fontSize: 15,
        fontSizeLG: 17,
        lineHeight: 1.6,
        controlHeight: 36,
        controlHeightLG: 42,
        borderRadius: 8,
      },
      components: {
        Menu: { itemHeight: 44, iconSize: 17 },
        Table: { cellPaddingBlock: 14, cellPaddingInline: 18 },
        Card: { bodyPadding: 26, headerHeight: 60 },
        Form: { itemMarginBottom: 22 },
      },
    }"
  >
    <router-view />
  </a-config-provider>
</template>
